import { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getCurrentYearTeachersData } from '../reportUtilities';
import Spinner from 'react-spinkit';
import Table from '../Tables/Table';
import generalStyles from './SchoolReport.module.scss';
import styles from './TopEngagedTeachers.module.scss';
import { TeacherClassroomMaps, ReportingMixpanelEvent } from '../../../peekapak-types/ReportDataExchangeTypes';
import { UserProfileType } from '../../../peekapak-types/DataProtocolTypes';

interface Props {
  legacyPlatformEvents: ReportingMixpanelEvent[];
  legacyPlatformEventsReady: boolean;
  newMixpanelEvents: ReportingMixpanelEvent[];
  newMixpanelEventsReady: boolean;
  teacherClassroomMaps: TeacherClassroomMaps;
  teacherClassroomMapsReady: boolean;
  legacyPeekavilleEvents: ReportingMixpanelEvent[];
  legacyPeekavilleEventsReady: boolean;
  selectedSchoolYear: string;
  userList: UserProfileType[];
  userListReady: boolean;
}

const TopEngagedTeachers = ({
  legacyPlatformEvents,
  legacyPlatformEventsReady,
  teacherClassroomMaps,
  teacherClassroomMapsReady,
  userList,
  userListReady,
  selectedSchoolYear,
  legacyPeekavilleEvents,
  legacyPeekavilleEventsReady,
  newMixpanelEvents,
  newMixpanelEventsReady,
}: Props): JSX.Element => {
  const [myState, setMyState] = useState({
    dataMap: {},
    dataMapReady: false,
  });

  useEffect(() => {
    setMyState((prevState) => ({
      ...prevState,
      dataMap: {},
      dataMapReady: false,
    }));
  }, [legacyPlatformEvents, legacyPeekavilleEvents, newMixpanelEvents]);

  useEffect(() => {
    if (
      legacyPlatformEventsReady &&
      legacyPeekavilleEventsReady &&
      teacherClassroomMapsReady &&
      newMixpanelEventsReady &&
      !myState.dataMapReady
    ) {
      buildData();
    }

    function buildData() {
      const newTeacherMap = getCurrentYearTeachersData(
        userList,
        teacherClassroomMaps,
        legacyPlatformEvents,
        newMixpanelEvents,
      );

      setMyState((prevState) => ({
        ...prevState,
        dataMap: newTeacherMap,
        dataMapReady: true,
      }));
    }
  }, [
    teacherClassroomMaps,
    teacherClassroomMapsReady,
    legacyPeekavilleEventsReady,
    legacyPeekavilleEvents,
    legacyPlatformEvents,
    legacyPlatformEventsReady,
    newMixpanelEvents,
    newMixpanelEventsReady,
    selectedSchoolYear,
    myState.dataMap,
    myState.dataMapReady,
    userList,
  ]);

  return (
    <div className={styles.topEngagedTeachers}>
      <h4 className={generalStyles.tableHeader}>Top Engaged Teachers</h4>
      <Table
        // tableHeader={['Full Name', 'Logins', 'Total Time (min)']}
        tableHeader={[{ title: 'Full Name' }, { title: 'Logins' }]}
      >
        {getContent()}
      </Table>
    </div>
  );

  function getContent() {
    if (!legacyPlatformEventsReady || !userListReady || !legacyPeekavilleEventsReady || !newMixpanelEventsReady) {
      return (
        <tr>
          <td className={generalStyles.tdForProgressMessage}>
            <div className={generalStyles.progressMessage}>
              Loading
              <Spinner name='line-scale' />
            </div>
          </td>
        </tr>
      );
    }

    return <>{getTopEngagedTeachers()}</>;
  }

  function getTopEngagedTeachers() {
    const sorted = Object.values(myState.dataMap).sort((a: any, b: any) => b.loginTimes - a.loginTimes);

    const toReturn = sorted.slice(0, Math.min(5, sorted.length));

    if (toReturn.length === 0) {
      return (
        <tr>
          <td className={generalStyles.tdForProgressMessage}>
            <div className={generalStyles.progressMessage}>No data available</div>
          </td>
        </tr>
      );
    }

    return (
      <>
        {/* {toReturn.map((e: any, i) =>
          e.loginTimes || getTotalTime(i) ? (
          <tr>...</tr>
          ) : null
        )} */}
        {toReturn.map((e: any, i) => (
          <tr key={e.username}>
            <td>
              {e.email || e.userId ? (
                <OverlayTrigger
                  placement='top'
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip id={`teacher-tooltip-${i}`}>{e.email || e.userId}</Tooltip>}
                  onToggle={(show) => {
                    if (show) {
                      console.log(`${e.lastName}, ${e.firstName}: ${e.email || e.userId}`);
                    }
                  }}
                >
                  <span>{`${e.lastName}, ${e.firstName}`}</span>
                </OverlayTrigger>
              ) : (
                `${e.lastName}, ${e.firstName}`
              )}
            </td>
            <td>{e.loginTimes}</td>
          </tr>
        ))}
      </>
    );
  }
};

export default TopEngagedTeachers;
